module.exports = __webpack_public_path__ + "img/f_logo.9b074be2.png";